// extracted by mini-css-extract-plugin
export default {"button":"style_button__Y9QKF","button--disabled":"style_button--disabled__stMSt","button__label":"style_button__label__g45IA"};